module.exports = "<div class=\"report-header group\">\r\n    <p class=\"report-header-citation\">{{Citation}}</p>\r\n    <p class=\"report-header-text\">This document contains multiple reports for this report series</p>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/desktop/views/partials/report-header.html
// module id = 354
// module chunks = 1